import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex);

// Oturum saatini tutuyor. Dikkat!!! SAAT türünde olmalı.
const expireHour = 3;

const initialStates = () => ({
    status: '',
    response: '',
    token: '',
    iys_status: null,
    referenceFormStatus: false,
    whatsappQrModal: false,
    whatsappInfoModal: true,
    whatsappInfoFormModal: false,
    twoFA: {
        resend: '',
        state: false,
    },
    showWhatsappPhoneCodeModal: false,

    selection: {
        numbers: [],
        username: null,
        password: null,
    },
    tawk: '',
    user: {},
    // giriş yapan temsilci mi
    is_customer_service: false,
    // holdMyBeer: true,
    notification: false,
    notificationCentered: false,
    notificationTimeout: 3000,
    notificationColor: '',
    notificationPopup: {},
    dialog: {
        confirmation: false,
        action: null,
    },
    modal: {
        open: false,
        index: -1,
        data: {},
        editedData: {},
    },
    freeZone: null,
    disableSendWhatsappButton: false,

});

const store = new Vuex.Store({
    state: initialStates,
    mutations: {
        updateField,
        setNotificationPopup: (state, payload) => {
            state.notificationPopup = payload;
        },
        setShowWhatsappPhoneCodeModal(state, value) {
            state.showWhatsappPhoneCodeModal = value;
          },
          setDisableSendWhatsappButton: (state, payload) => {
            state.disableSendWhatsappButton = payload;
          },
          updateWhatsappQrModal: (state, payload) => {
            state.whatsappQrModal = payload;
          },
          updateWhatsappInfoModal: (state, payload) => {
            state.whatsappInfoModal = payload;
          },
          updateWhatsappInfoFormModal: (state, payload) => {
            state.whatsappInfoFormModal = payload;
          },
        setNotificationTimeout: (state, payload) => {
            state.notificationTimeout = payload;
        },
        setNotificationColor: (state, payload) => {
            state.notificationColor = payload;
        },
        setResponse: (state, payload) => {
            state.response = payload;
        },
        notificationCentered: (state, payload) => {
            state.notificationCentered = payload;
        },
        updateReferenceFormStatus: (state, payload) => {
            state.referenceFormStatus = payload;
        },
        setIsCustomerService: (state, payload) => {
            state.is_customer_service = payload;
        },
        setTwoFA: (state, data) => {
            state.twoFA = data;
        },
        setSelection: (state, data) => {
            state.selection = data;
        },
        auth_request: (state) => {
            state.status = 'loading';
        },
        auth_success: (state, data) => {
            state.status = 'success';
            state.token = data.token;
            state.user = data.user;
            state.response = data.response;
            state.iys_status = data.iys_status;
        },
        auth_error: (state, response) => {
            state.status = 'error';
            state.response = response;
        },
        logout: (state) => {
            state.status = '';
            state.token = '';
            state.tawk = '';
            state.user = {
                name: '',
                surname: '',
            };
            state.is_customer_service = false;
            localStorage.removeItem('expiresAt');
        },

        updateModal(state, value) {
            state.modal.open = value;
        },

        sendRequest: (state) => {
            state.status = 'loading';
        },
        send: (state, description, status) => {
            state.status = status;
            state.response = description;
        },
        setTawk: (state, tok) => {
            state.tawk = tok;
        },

        fireNotification: (state) => {
            state.notification = state.response !== '';
        },
        fireConfirmation: (state, action) => {
            state.dialog.confirmation = true;
            state.dialog.action = action;
        },
        reset(state) {
            // acquire initial state
            const s = initialStates();
            Object.keys(s)
                .forEach((key) => {
                    if (key !== 'user' && key !== 'token') {
                        state[key] = s[key];
                    }
                });
        },
    },

    getters: {
        apiEndpoint: () => 'https://api.vatansms.com/api/',
        // apiEndpoint: () => "http://192.168.1.119:8181/api/",
        // apiEndpoint: () => 'http://localhost:8000/api/',
        getReferenceFormStatus: state => state.referenceFormStatus,
        getNotificationPopup: (state) => state.notificationPopup,
        getDisableSendWhatsappButton: (state) => state.disableSendWhatsappButton,
        getWhatsappQrModal: (state) => state.whatsappQrModal,

        loading: (state) => state.status === 'loading',
        isLoggedIn: (state) => !!(state.token && state.twoFA.state),
        authStatus: (state) => state.status,
        getModal: (state) => state.modal.open,
        notificationTimeout: (state) => state.notificationTimeout,
        notificationColor: (state) => state.notificationColor,
        confirmationDialog: (state) => state.confirmation,
        notificationCentered: isCentered => state.notificationCentered = isCentered,
        getField,
    },
    actions: {
        async notification({getters}, dataInfo) {
            return new Promise(async (resolve, reject) => {
                await Vue.axios({
                    url: `${getters.apiEndpoint}/b/notification`,
                    data: dataInfo.data,
                    method: 'POST',
                    headers: dataInfo.headers,
                    responseType: dataInfo.type,
                }).then((res) => {
                    resolve(res)
                }).catch((error) => {
                    reject(error)
                });
            });
        },
        async asyncSender({ commit,getters }, dataInfo) {
            return new Promise(async (resolve, reject) => {
                await Vue.axios({
                    url: `${getters.apiEndpoint}${dataInfo.route}`,
                    data: dataInfo.data,
                    method: 'POST',
                    headers: dataInfo.headers,
                    responseType: dataInfo.type,
                })
                    .then((res) => {
                        if (res !== undefined) {
                            if (res.data.data.code >= 400) {
                                commit("send", res.data.data.description, "error");
                                commit("fireNotification");
                                reject(res);
                            }
                            resolve(res.data);
                            // eslint-disable-next-line no-console
                        }
                    })
                    .catch((err) => {
                        reject(err);
                        // eslint-disable-next-line no-console
                    });
            });
        },
        disableSendWhatsappButtonAction(context, val) {
            context.commit("setDisableSendWhatsappButton", val);
          },
        sendBackend: ({
                          commit,
                          getters,
                          state
                      }, dataInfo) =>
            new Promise((resolve, reject) => {
                commit('sendRequest');
                Vue.axios({
                    url: `${getters.apiEndpoint}${dataInfo.route}`,
                    data: dataInfo.data,
                    method: 'POST',
                    headers: dataInfo.headers,
                    statusCode: 500,
                    responseType: dataInfo.type,
                })
                    .then((res) => {
                        if (res !== undefined) {
                            const description = res.data.description || '';
                            if (typeof res !== 'undefined' && !res.data.confirmation) {
                                commit('send', description, 'success');
                                commit('fireNotification');
                            } else {
                                commit('send', null, 'success');
                            }

                            if (res.data.code >= 400) {
                                commit('send', description, 'error');
                                commit('fireNotification');
                                reject(description);
                            }

                            resolve(res);
                            // eslint-disable-next-line no-console
                        }
                    })
                    .catch((err) => {
                        if (err.includes('Yeni sunucu kapsamında giriş')) {
                            err = 'Değerli Müşterimiz; Girişleri VATANSMS.NET sayfasından yapmanız gerekmektedir, Otomatik yönlendiriliyorsunuz…';
                            setTimeout(() => window.location.href = `https://app.vatansms.net/login?username=${dataInfo.data.username}`, 3000);
                        }

                        if (dataInfo.route === 'two/step/login') {
                            state.notificationCentered = true;
                        }

                        commit('send', err, 'error');
                        commit('fireNotification');

                        reject(err);
                        // eslint-disable-next-line no-console
                    });
            }),

        login({commit, getters}, data) {
            return new Promise((resolve, reject) => {
                commit('auth_request');
                commit('sendRequest');
                let url = `${getters.apiEndpoint}two/step/do/login`;
                if (data.protected) {
                    // eslint-disable-next-line no-prototype-builtins
                    url = `${getters.apiEndpoint}admin/login`;
                    // eslint-disable-next-line no-param-reassign
                    delete data.protected;
                }
                if (data.logInSubUser) {
                    url = `${getters.apiEndpoint}login/subuser`;
                    // eslint-disable-next-line no-param-reassign
                    delete data.logInSubUser;
                }
                Vue.axios({
                    data,
                    url,
                    method: 'POST',
                })
                    .then((res) => {
                        if (res !== undefined) {
                            if (res.data.code >= 400) {
                                commit('send', res.data.description, 'error');
                                commit('fireNotification');
                                reject(res.data.description);
                            } else {
                                const description = res.data.description || '';
                                // eslint-disable-next-line no-prototype-builtins
                                const token = res.data.data.jwt.hasOwnProperty('original')
                                    ? res.data.data.jwt.original.access_token
                                    : res.data.data.jwt;

                                // kullanıcının giriş yaptığı saatin 'expireHour' fazlası ekleniyor.
                                // bunun kontrolü ise 'App.vue' da yapılıyor.
                                const date = new Date();
                                date.setHours(date.getHours() + expireHour);

                                localStorage.setItem('expiresAt', date);

                                // ilk girişin başarılı olması için default header a response dan
                                // gelen token ı veriyorum. İkinci aşamada gelen token i vuex'e
                                // kaydettiğim için, main.js içerisinde axios un headerını vuex'e
                                // kayıtlı olan token dan okuyarak değiştiriyorum.

                                // NOT(v2): bu satıra gerek yok. Main.js de halledildi.
                                // gelecek sürümde silinebilir.
                                Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                                commit('send', description, 'success');
                                commit('fireNotification');
                                commit('auth_success', {
                                    token,
                                    user: {
                                        ...res.data.data.user,
                                        can_send_sms: res.data.data.can_send_sms,
                                    },
                                    response: 'Başarıyla giriş yapıldı.',
                                    iys_status: res.data.data.iys_status,
                                });
                                // commit('setTawk', res.data.data.tawk_to_visitor);

                                resolve(res);
                            }
                        }
                    })
                    .catch((err) => {
                        commit('auth_error', err);
                        Vue.prototype.$session.remove('token');
                        commit('fireNotification');

                        reject(err);
                    });
            });
        },

        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout');
                localStorage.removeItem('token');
                delete Vue.axios.defaults.headers.common.Authorization;

                resolve();
            });
        },

        updateModal({ commit }, value) {
            commit('updateModal', value);
        },
    },
    plugins: [
        // eslint-disable-next-line no-shadow
        (store) => {
            store.subscribe((mutation, state) => {
                const { payload } = mutation;
                if (
                    payload &&
                    payload.path === 'modal.open' &&
                    payload.value === false
                ) {
                    state.modal.index = -1;
                    state.modal.editedData = {};

                    state.freeZone = null;
                }
            });
        },
        createPersistedState(),
    ],
});

export default store;
